import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home/Home";
import ComDomainRegistration from "./pages/ComDomainRegistration/ComDomainRegistration";
import AEDomainRegistration from "./pages/AEDomainRegistration/AEDomainRegistration";
import BannerAdsManagement from "./pages/BannerAdsManagement/BannerAdsManagement";
import BlogDevelopment from "./pages/BlogDevelopment/BlogDevelopment";
import BrandManagement from "./pages/BrandManagement/BrandManagement";
import BrandMarketingStrategy from "./pages/BrandMarketingStrategy/BrandMarketingStrategy";
import BrochureDesigning from "./pages/BrochureDesigning/BrochureDesigning";
import BusinessCardDesign from "./pages/BusinessCardDesign/BusinessCardDesign";
import CorporateIdentity from "./pages/CorporateIdentity/CorporateIdentity";
import DynamicWebsiteDesigning from "./pages/DynamicWebsiteDesigning/DynamicWebsiteDesigning";
import EBrochure from "./pages/EBrochure/EBrochure";
import ECommerceWebsite from "./pages/ECommerceWebsite/ECommerceWebsite";
import EmailMarketing from "./pages/EmailMarketing/EmailMarketing";
import FlashWebsites from "./pages/FlashWebsites/FlashWebsites";
import InformationArchitectureStrategyPlanning from "./pages/InformationArchitectureStrategyPlanning/InformationArchitectureStrategyPlanning";
import LeadGeneration from "./pages/LeadGeneration/LeadGeneration";
import LogoDesign from "./pages/LogoDesign/LogoDesign";
import MobileAppsDevelopment from "./pages/MobileAppsDevelopment/MobileAppsDevelopment";
import MobileWebsiteDesign from "./pages/MobileWebsiteDesign/MobileWebsiteDesign";
import PayPerClickCampaignAdvertising from "./pages/PayPerClickCampaignAdvertising/PayPerClickCampaignAdvertising";
import PersonalizedProductCatalogs from "./pages/PersonalizedProductCatalogs/PersonalizedProductCatalogs";
import Pricing from "./pages/Pricing/Pricing";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import ProfileDesigning from "./pages/ProfileDesigning/ProfileDesigning";
import ResponsiveWebsiteDesigning from "./pages/ResponsiveWebsiteDesigning/ResponsiveWebsiteDesigning";
import SMSMarketing from "./pages/SMSMarketing/SMSMarketing";
import SearchEngineOptimization from "./pages/SearchEngineOptimization/SearchEngineOptimization";
import SocialMediaApplicationDevelopment from "./pages/SocialMediaApplicationDevelopment/SocialMediaApplicationDevelopment";
import SocialMediaMarketing from "./pages/SocialMediaMarketing/SocialMediaMarketing";
import StaticWebsiteDesigning from "./pages/StaticWebsiteDesigning/StaticWebsiteDesigning";
import UserInterfaceDesignService from "./pages/UserInterfaceDesignService/UserInterfaceDesignService";
import WebPortals from "./pages/WebPortals/WebPortals";
import WebsiteMaintainence from "./pages/WebsiteMaintainence/WebsiteMaintainence";
import WebsiteMaintenance from "./pages/WebsiteMaintenance/WebsiteMaintenance";
import AboutUs from "./pages/AboutUs/AboutUs";
import Clients from "./pages/Clients/Clients";
import ContactUs from "./pages/ContactUs/ContactUs";
import DedicatedHosting from "./pages/DedicatedHosting/DedicatedHosting";
import DigitalMarketingPackages from "./pages/DigitalMarketingPackages/DigitalMarketingPackages";
import FacebookAdvertisingAgency from "./pages/FacebookAdvertisingAgency/FacebookAdvertisingAgency";
import Portfolio from "./pages/Portfolio/Portfolio";
import RegisteringDomain from "./pages/RegisteringDomain/RegisteringDomain";
import RenewalOfDomain from "./pages/RenewalOfDomain/RenewalOfDomain";
import SearchEngineMarketing from "./pages/SearchEngineMarketing/SearchEngineMarketing";
import SharingHosting from "./pages/SharingHosting/SharingHosting";
import TransferringOfDomain from "./pages/TransferringOfDomain/TransferringOfDomain";
import WebDesignPackages from "./pages/WebDesignPackages/WebDesignPackages";
import WebDesigningCompany from "./pages/WebDesigningCompany/WebDesigningCompany";
import WebDevelopment from "./pages/WebDevelopment/WebDevelopment";
import WebsiteHosting from "./pages/WebsiteHosting/WebsiteHosting";
import Blog from "./pages/Blog/Blog";
import BlogDetail from "./pages/BlogDetail/BlogDetail";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div id="page" className="page">
          <Header />

          <Routes>
            <Route path="/" element={<Home />} />
        <Route path="/.com-domain-registration" element={<ComDomainRegistration />} />
        <Route path="/ae-domain-registration" element={<AEDomainRegistration />} />
        <Route path="/banner-ads-management" element={<BannerAdsManagement />} />
        <Route path="/blog-development" element={<BlogDevelopment />} />
        <Route path="/brand-management" element={<BrandManagement />} />
        <Route path="/brand-marketing-strategy" element={<BrandMarketingStrategy />} />
        <Route path="/brochure-designing" element={<BrochureDesigning />} />
        <Route path="/business-card-design" element={<BusinessCardDesign />} />
        <Route path="/corporate-identity" element={<CorporateIdentity />} />
        <Route path="/dynamic-website-designing" element={<DynamicWebsiteDesigning />} />
        <Route path="/e-brochure" element={<EBrochure />} />
        <Route path="/e-commerce-website" element={<ECommerceWebsite />} />
        <Route path="/email-marketing" element={<EmailMarketing />} />
        <Route path="/flash-websites" element={<FlashWebsites />} />
        <Route path="/information-architecture-strategy-planning" element={<InformationArchitectureStrategyPlanning />} />
        <Route path="/lead-generation" element={<LeadGeneration />} />
        <Route path="/logo-design" element={<LogoDesign />} />
        <Route path="/mobile-apps-development" element={<MobileAppsDevelopment />} />
        <Route path="/mobile-website-design" element={<MobileWebsiteDesign />} />
        <Route path="/pay-per-click-campaign-advertising" element={<PayPerClickCampaignAdvertising />} />
        <Route path="/personalized-product-catalogs" element={<PersonalizedProductCatalogs />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/profile-designing" element={<ProfileDesigning />} />
        <Route path="/responsive-website-designing" element={<ResponsiveWebsiteDesigning />} />
        <Route path="/sms-marketing" element={<SMSMarketing />} />
        <Route path="/search-engine-optimization" element={<SearchEngineOptimization />} />
        <Route path="/social-media-application-development" element={<SocialMediaApplicationDevelopment />} />
        <Route path="/social-media-marketing" element={<SocialMediaMarketing />} />
        <Route path="/static-website-designing" element={<StaticWebsiteDesigning />} />
        <Route path="/user-interface-design-service" element={<UserInterfaceDesignService />} />
        <Route path="/web-portals" element={<WebPortals />} />
        <Route path="/website-maintainence" element={<WebsiteMaintainence />} />
        <Route path="/website-maintenance" element={<WebsiteMaintenance />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/clients" element={<Clients />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/dedicated-hosting" element={<DedicatedHosting />} />
        <Route path="/digital-marketing-packages" element={<DigitalMarketingPackages />} />
        <Route path="/facebook-advertising-agency" element={<FacebookAdvertisingAgency />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/registering-domain" element={<RegisteringDomain />} />
        <Route path="/renewal-of-domain" element={<RenewalOfDomain />} />
        <Route path="/search-engine-marketing" element={<SearchEngineMarketing />} />
        <Route path="/sharing-hosting" element={<SharingHosting />} />
        <Route path="/transferring-of-domain" element={<TransferringOfDomain />} />
        <Route path="/web-design-packages" element={<WebDesignPackages />} />
        <Route path="/web-designing-company" element={<WebDesigningCompany />} />
        <Route path="/web-development" element={<WebDevelopment />} />
        <Route path="/website-hosting" element={<WebsiteHosting />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slugId" element={<BlogDetail />} />
          </Routes>

          <Footer />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
